import template from './CookieBannerView.hbs';

import {router} from '../../../js/router';
import './CookieBannerView.less';
import {CookieUtils} from '../../utils/CookieUtils';
import {BaseView, Prototype} from '../../../shared/view/BaseView';

/**
 * @class CookieBannerView
 * @extends BaseView
 *
 * @property {ResourceLocator} model
 */
@Prototype({
    template,
    className: 'cookie-banner-view',
})
export class CookieBannerView extends BaseView {

    initialize () {
        Radio.channel('ROUTER').on('ROUTE:FINISH', this.onRouteFinish , this);
    }

    onRouteFinish () {
        let routeEvent = router.getLastEvent();

        this.locale = ((routeEvent && routeEvent.routeNamedArgs) ? routeEvent.routeNamedArgs.languageCode : 'en_de');
        this.render();
    }

    closeCookieBanner () {
        let cookieConfigs = CookieUtils.COOKIE_CONFIGS.cookieBannerConfigs;

        CookieUtils.setCookie(
            cookieConfigs.cookieName,
            cookieConfigs.valueToStoreAndCheck,
            cookieConfigs.expirationTime,
        );

        this.destroy();
    }

    serializeData () {
        let path = '/docs/privacy/' + this.locale + '.html';

        return {
            path: path,
            cookieText: __('BASICLAYOUT.COOKIE_BANNER_VIEW.COOKIE_TEXT'),
            dataPrivacyLabel: __('BASICLAYOUT.COOKIE_BANNER_VIEW.DATA_PRIVACY_STATEMENT'),
            closeCookieBanner: () => this.closeCookieBanner(),
        };
    }

    onDestroy () {
        Radio.channel('ROUTER').off('ROUTE:FINISH', this.onRouteFinish, this);
        Radio.channel('COOKIE_BANNER').trigger('CLOSE:COOKIE_BANNER');
    }

}


// WEBPACK FOOTER //
// ./shared/view/CookieBannerView/CookieBannerView.js